import { Heading5Props } from "./types"
import React from "react"
import { HeadingCore } from "./core"

const Heading5: React.FC<Heading5Props> = (props) => {
  return <HeadingCore {...props} fontSize={"2xl"} />
}

export default Heading5
